import { KontentFilterable } from "types/CMS/Unum/filterable";
import { allProductTypes } from "types/enums/Products/Products";

export const productTaxonomyFilter = <TResolved extends KontentFilterable>(
  input: TResolved | undefined,
  usersProducts?: allProductTypes[],
) => {
  if (!input) {
    return false;
  }

  if (!input?.productTaxonomy || input?.productTaxonomy?.length === 0) {
    return true;
  }

  return input.productTaxonomy.some((taxonomy) =>
    usersProducts?.includes(taxonomy),
  );
};